module.exports = __webpack_public_path__ + "dash_20_app_assets/img/sandrlogos.a16d83d3.png";